import { NotificationManager } from "../services/notifications/notificationManager";
import { NotificationStepData } from "./notification/notificationStepData";
import { Component, Vue } from "vue-facing-decorator";

@Component({
    name: "NotificationBase",
})
export class NotificationBase extends Vue {
    stepData: NotificationStepData = null;

    addListener(scopes) {
        NotificationManager.addListener(scopes, this, this.onMessage);
    }

    removeListener() {
        NotificationManager.removeListener(this.onMessage);
    }

    setNotificationStepData(id: string, onRunning, onEnded) {
        // console.log("setNotificationStepData id=", id);
        this.stepData = new NotificationStepData(id, onRunning, onEnded);
    }

    resetNotificationStepData() {
        this.stepData = null;
    }

    onMessage(data) {
        // console.log("onMessage", data);
        if (this.stepData) {
            this.stepData.onMessage(data);
        } else {
            debugger;
        }
    }
}
